import React from "react";
import styled from "styled-components";

import { hsl } from "../../utils/color";
import constants from "../../utils/constants";

const Styled = styled.div<Props>`
  width: 20rem;
  padding: 0.1rem;
  background-color: ${(props) => hsl(props.theme.colors?.surface0.color)};
  border: solid 1px #b5b5b5;
  box-shadow: ${constants.shadow};
  border-radius: ${constants.radius};
  overflow: hidden;
`;

const Title = styled.div`
  padding: 1rem;
  color: #888;
  text-transform: uppercase;
  border-bottom: solid 1px #ddd;
  font-size: 1rem;
  font-weight: 500;
  background-color: #f7f7f7;
`;

export const MenuDivider = styled.div`
  border-top: solid 1px #ddd;
  margin: 0.5rem;
`;
export const MenuButtons = styled.div`
  padding: 0.5rem;
`;

interface Props {
  menuTitle?: string;
}

const Menu: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <Styled {...props}>
      {!!props.menuTitle && <Title>{props.menuTitle}</Title>}
      {props.children}
    </Styled>
  );
};

export default Menu;
